import { BASE_URL } from "../components/seo/SEO";

export function webApplicationSchema(calc) {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: calc.name,
    url: `${BASE_URL}/calculators/${calc.slug}`,
    applicationCategory: "FinanceApplication",
    operatingSystem: "Web",
    description: calc.seo?.description,
    offers: { "@type": "Offer", price: "0", priceCurrency: "CAD" },
    inLanguage: "en-CA",
    areaServed: "CA",
  };
}

export function faqSchema(faq) {
  if (!faq?.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: `${BASE_URL}${it.to}`,
    })),
  };
}

export function productSchema(p) {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: p.name,
    description: p.description,
    image: p.image,
    offers: {
      "@type": "Offer",
      price: String(p.price),
      priceCurrency: "CAD",
      availability: "https://schema.org/InStock",
      url: p.gumroadUrl,
    },
  };
}

// Merge multiple schema objects into an @graph document.
export function mergeSchema(...objs) {
  const graph = objs.filter(Boolean);
  if (!graph.length) return null;
  if (graph.length === 1) return graph[0];
  return { "@context": "https://schema.org", "@graph": graph.map(({ "@context": _c, ...rest }) => rest) };
}
